<template>
    <div class="view view__event_edit_completions">
        <event-edit-completions ref="childcomponent"/>
    </div>
</template>

<script>
import EventEditCompletions from '@/components/ebs/events/edit/EventEditCompletions'
import { validateAllowRedirectBeforeRouteLeave } from '@/helpers/mixins'

export default {
  components: { EventEditCompletions },
  name: 'view-event-edit-completions',
  mixins: [validateAllowRedirectBeforeRouteLeave]
}
</script>
